<template>
    <div class="wait_icon_cover" :class="{ button_loading: buttonLoading }">
        <img src="../../assets/pageLoadingIcon.gif" :class="{ button_loading: buttonLoading }" />
    </div>
</template>

<script>
export default {
    props: ["buttonLoading"]
}
</script>

<style scoped>
.wait_icon_cover {
    position: relative;
    width: 24px;
    height: 29px;
    margin: auto;
    top: 48%;
}

.button_loading {
    width: 14px !important;
    height: 19px !important;
}
</style>